module.exports = __webpack_public_path__ + "img/vendor_logo1.cc35461c.png";